<script>
	
  import { getName, LogOut, checkCookie, setCookie, getCookie } from '../utils/utils.js';
  //import Shafts from './Shafts.svelte'
  import CreateForm from './CreateForm.svelte'
  import UserBalance from './UserBalance.svelte'
  import Icon from '@iconify/svelte';
  import signOut16 from '@iconify/icons-octicon/sign-out-16';
  import outlineDownloadForOffline from '@iconify/icons-ic/outline-download-for-offline';
  import codeDownload from '@iconify/icons-ion/code-download';
  import generatePdf from '@iconify/icons-carbon/generate-pdf';

  import JobsList from './JobsList.svelte'

  let jobs_list;
  

  //import Userfront from "@userfront/core"; // test
  //Userfront.init("6bgdz9n7");               // test
  
	var name = getName();
  
  
    //let object=await response.clone().json()
    //console.log(object.shafts[0].x)

    
    //return response.json(); // parses JSON response into native JavaScript objects
    
  //$: console.log(object);

  if (window.navigator.cookieEnabled && checkCookie("id.6bgdz9n7")) {
    console.log("Detected id.6bgdz9n7")
    setCookie("radegerreturninguser", "yes", 100)
  } else {
    if (window.location.hostname.includes("radeger.com") && window.location.includes("app") ) {
        window.location.replace("/login.html");
    } 
  }
  
  let reducer_ref="";
  let reducer_bg_image="";
  let reducer_pdf="";
  let reducer_png="";
  let reducer_svg="";
  $: if(reducer_ref == "") {
        reducer_bg_image="";
        //console.log("img:",reducer_bg_image)
      } else {
        reducer_bg_image="background-image: url('https://radeger03.s3.eu-central-1.amazonaws.com/".concat(reducer_ref,"-0.png');background-repeat: no-repeat;background-size: contain;background-position: top right;");
        reducer_png="https://radeger03.s3.eu-central-1.amazonaws.com/".concat(reducer_ref,"-0.png");
        reducer_svg="https://radeger03.s3.eu-central-1.amazonaws.com/".concat(reducer_ref,"-0.svg");
        reducer_pdf="https://radeger03.s3.eu-central-1.amazonaws.com/".concat(reducer_ref,"-0.pdf");
        //console.log("img:",reducer_bg_image)
      };

  function contactAdmin() {
    alert("Please feel free to contact info@radeger.com via email. Consider including the reducer reference number and a screenshot.")
  }
  function showDocumentation() {
    reducer_ref=""
  }

</script>

<div class="outer-grid-container">
    <div class="head">
      <ul>
        <div>
          <li><a href="https://www.radeger.com"><div id="logo">RADEGER</div></a></li>
          <li><a href="https://www.radeger.com/app" class="active">App</a></li>
          <UserBalance />
        </div>
        <div class="right">
          <li on:click={contactAdmin}><a href="#contact">Contact</a></li>
          <li on:click={showDocumentation}><a href="#doc">Documentation</a></li>
          <li><a id="logoutbtn" href="/index.html" onclick="LogOut()"> <Icon icon={signOut16} color="white" inline={true} /> Log out</a></li>
        </div>
        
      </ul>
    </div>
    <div class="inner-grid-container">
      <div class="side-grid-container">
        <CreateForm on:create-event={() => jobs_list.refresh()}/>
        
        <JobsList bind:this={jobs_list} bind:selected_reducer={reducer_ref}/>
        
      </div>
      <div class="view" style={reducer_bg_image}>
        {#if reducer_ref != ""}
        <aside>
          <h3>Reference number: {reducer_ref}</h3>
        </aside>
        <div class="flexright"><a href={reducer_png} ><Icon icon={outlineDownloadForOffline} width="36" height="36" color="blue" /></a></div>
        <div class="flexright"><a href={reducer_svg} ><Icon icon={codeDownload} color="blue" width="36" height="36" /></a></div>
        <div class="flexright"><a href={reducer_pdf} ><Icon icon={generatePdf} color="blue" width="36" height="36" /></a></div>
        {:else}
         <h3 id="doc">Instructions:</h3>
         <p>1. Create a reducer by filling out the form.</p>
         <p>2. Refresh the list to keep up with updates.</p>
         <p>3. Select Quote on an item in the list. Indicated amount will be deduced from your balance.</p>
         <p>4. Select Compute to start the computation. Indicated amount will be deduced from your balance.</p>
         <p>5. Select View to visually examine computed reducer.</p>
         <p>6. Download icons are on the right side of the screen</p>
         <p>7. Archive items you are no longer interested in.</p>
        {/if}
      </div>
    </div>
    <div class="foot">&copy; Radeger 2021</div>
  </div>

  <style>

.flexright {
  display: flex;
  justify-content: right;
  height: auto;
  border: none; 
  margin: 5px;
}
    
aside h3 {
  font: bold 24px Sans-Serif;
  letter-spacing: 2px;
  background: #369;
  color: #fff;
  padding: 5px 10px;
  margin: 0 0 10px 0;
  transform: rotate(270deg) translate(-600px, 0%) ;
  transform-origin: left top;
}
  
  .right {
    float: right;
    /* width: 20%; */
    
    padding: 0px;
    padding-right: 0px;
    padding-left: 0px;
  }


#logo {
    font-family: 'Alegreya Sans SC';
    color: #6baed6;
    letter-spacing: 10px;
    text-shadow: #9ecae1 2px 1px;
    font-size: 28px;
    
    }


  
  
  .outer-grid-container {
    height: 100vh;
    width: 100vw;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1fr min-content;
    overflow: hidden;
    padding: 0px;
    margin: 0px;
  }
  
  .inner-grid-container {
    display: grid;
    grid-template-columns: max-content 1fr;
    overflow: hidden;
    background-color: black;
    grid-gap: 0px 3px;
    padding: 0px;
    margin: 0px;
    height: 100%;
  }
  
  .side-grid-container {
    display: grid;
    grid-template-rows: min-content 1fr;
    overflow: hidden;
    background-color: black;
    grid-gap: 3px 0px;
    padding: 0px;
    margin: 0px;
  }
  
  .head { 
    /*max-height: 20 px;*/
    background-color: #6baed6;
    color: white;
    font-size: 20px;
    text-align: center;
    padding: 0px;
    margin: 0px;
  }
  
  .view { 
    background-color: rgb(255, 255, 216); 
    padding: 0px;
  }
  .foot { 
    background-color: rgb(184, 235, 255);
    text-align: center;
  }
  
  /* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
  /* @media (max-width: 900px) {
    .grid-container  {
      grid-template-areas: 
        'form' 
        'list' 
        'view' 
        'foot';
    }
  } */
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #333;
  }
  
  li {
    float: left;
    border-left: none;
    border-right:1px solid #bbb;
  }
  
 
  
  
  li a {
    display: block;
    color: white;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
  }
  
  li a:hover:not(.active) {
    background-color: #111;
  }
  
  .active {
    background-color: #6baed6;
  }
  


  
  
  
  .right {
    float:right;
  }
  

  
  
  
  
  
  
  
  @keyframes blinker {
    30% {
      opacity: 0.2;
    }
  }
  
  #logo {
    font-family: 'Alegreya Sans SC';
    color: #6baed6;
    letter-spacing: 10px;
    text-shadow: #9ecae1 2px 1px;
    font-size: 20px;
    
  }
  


  </style>